<template>
    <transition-group
        name="staggered-fade"
        class="StaggeredFade"
        tag="div"
        appear
        @before-enter="beforeEnter"
        @enter="enter"
        @leave="leave"
    >
        <slot></slot>
    </transition-group>
</template>

<style lang="less" type="text/less">
.StaggeredFade > * {
    transition: all 0.3s ease-in-out;
}
</style>

<script type="text/babel">
export default {
    props: [],

    methods: {
        beforeEnter: function(el) {
            el.style.opacity = 0
            // el.style.height = 0
        },
        enter: function(el, done) {
            let delay = el.dataset.index * 80
            setTimeout(function() {
                el.style.opacity = 1
                done()
            }, delay)
        },
        leave: function(el, done) {
            let delay = el.dataset.index * 80
            setTimeout(function() {
                el.style.opacity = 0
                done()
            }, delay)
        },
    },
}
</script>
